import { useQuery } from '@tanstack/react-query';

import { useAccessToken } from 'reservations/account/providers/AccessTokenProvider';
import { type Config, ConfigResponse } from 'reservations/account/types';
import { BENTOBOX_CONFIG_ENDPOINT } from 'reservations/base/constants/endpoints';
import {
  REDIRECT_BASE_404,
  REDIRECT_WITH_ACCOUNT_DETAILS
} from 'reservations/base/constants/redirects';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { type RequestError, restClient } from 'utility/restClient';

async function fetchConfig(accessToken: string, slug: string) {
  const endpoint = buildBentoboxApiEndpoint(BENTOBOX_CONFIG_ENDPOINT, {
    access_token: encodeURIComponent(accessToken),
    slug
  });
  const response = await restClient.get(endpoint);

  try {
    return ConfigResponse.parse(response);
  } catch (err) {
    console.error('Error parsing config response:', err);
    throw err;
  }
}

export const useConfigQuery = () => {
  const { access_token: accessToken, slug } = useAccessToken();
  const { handleNavigation } = useCustomRouter();
  return useQuery({
    queryKey: ['config', accessToken, slug],
    queryFn: () => fetchConfig(accessToken, slug),
    enabled: true,
    retry: false,
    meta: {
      onQuerySuccess: (data: Config) => {
        if (!data.inGoodStanding) {
          handleNavigation(REDIRECT_WITH_ACCOUNT_DETAILS);
        }
      },
      onQueryError: (_: RequestError) => {
        // istanbul ignore next
        handleNavigation(REDIRECT_BASE_404);
      }
    }
  });
};
